import { HTMLProps, SetStateAction, useEffect, useRef, Dispatch } from 'react';

import { Stack } from 'components/Stack';

import { ReactComponent as IconArrowDown } from 'constants/icon/ic_arrow_count_down.svg';

function IndeterminateCheckbox({
  indeterminate,
  className = '',
  ...props
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !props.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return <input className={'extended-checkbox'} type="checkbox" ref={ref} {...props} />;
}

export function HeaderIndeterminateCheckbox({
  indeterminate,
  anchorIsOpen,
  setAnchorIsOpen,
  setAnchorPoint,
  className = '',
  ...props
}: {
  indeterminate?: boolean;
  anchorIsOpen: boolean;
  setAnchorIsOpen: Dispatch<SetStateAction<boolean>>;
  setAnchorPoint: Dispatch<SetStateAction<DOMRect | undefined>>;
} & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !props.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <Stack direction="row" spacing={4}>
      <input className={'extended-checkbox'} type="checkbox" ref={ref} {...props} />

      <IconArrowDown
        style={anchorIsOpen ? { transform: 'rotate(0.5turn)' } : {}}
        onClickCapture={e => {
          setAnchorIsOpen(prev => !prev);
          setAnchorPoint(e.currentTarget.getBoundingClientRect());
        }}
      />
    </Stack>
  );
}

export default IndeterminateCheckbox;
